<script setup>
import { useTablaTIREditar } from "@/composables/useTablaTIR";
import LoadingSpinner from "@/components/LoadingComponent";
const {
  cargando,
  cargandoPagina,
  getDatos,
  state,
  update,
} = useTablaTIREditar();

getDatos();
</script>

<template>
  <LoadingSpinner v-if="cargandoPagina" />
  <section v-else class="mx-auto col-md-8 mt-5">
    <h4 class="pb-2 border-bottom">{{ state.etiqueta }}</h4>

    <form class="mt-3" @submit.prevent="update">
      <div class="row">
        <div class="form-group col-md-3">
          <label for="tipo">Tipo</label>
          <input
            type="text"
            readonly
            class="form-control text-center"
            v-model="state.tipo"
            autocomplete="off"
            id="tipo"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="plazo">Moneda</label>
          <input
            type="text"
            readonly
            class="form-control text-center"
            v-model="state.moneda"
            autocomplete="off"
            id="moneda"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="plazo">Rango</label>
          <input
            type="text"
            readonly
            class="form-control text-center"
            v-model="state.rango"
            autocomplete="off"
            id="rango"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="plazo">Plazo</label>
          <input
            type="text"
            readonly
            class="form-control text-center"
            v-model="state.plazo"
            autocomplete="off"
            id="plazo"
          />
        </div>
        <div class="form-group col-md-12 align-middle">
          <h5>Datos</h5>
        </div>
        <div class="form-group col-md-3">
          <label for="anticipo">Anticipo capital</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control text-center"
              v-model="state.anticipo"
              autocomplete="off"
              id="anticipo"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="tasa">Tasa</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.tasa"
              autocomplete="off"
              id="tasa"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="comision">Comisión</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.comision"
              autocomplete="off"
              id="comision"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="ultima_renta">Última renta</label>
          <input
            type="tel"
            class="form-control text-center"
            v-model="state.ultima_renta"
            autocomplete="off"
            id="ultima_renta"
            required
          />
        </div>
        <div class="form-group col-md-3">
          <label for="residual_calculo">Residual cálculo</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.residual_calculo"
              autocomplete="off"
              id="residual_calculo"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="buy_out">Buy Out</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.buy_out"
              autocomplete="off"
              id="buy_out"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="residual_cliente">Residual cliente</label>
          <div class="input-group">
            <input
              readonly
              type="tel"
              class="form-control text-center"
              :value="
                parseFloat(state.residual_calculo) + parseFloat(state.buy_out)
              "
              autocomplete="off"
              id="residual_cliente"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="opcion_compra">Opción compra</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.opcion_compra"
              autocomplete="off"
              id="opcion_compra"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="tir_objetivo">TIR objetivo</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.tir_objetivo"
              autocomplete="off"
              id="tir_objetivo"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="tir_anterior">TIR anterior</label>
          <div class="input-group">
            <input
              type="tel"
              class="form-control text-center"
              v-model="state.tir_anterior"
              autocomplete="off"
              id="tir_anterior"
              required
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="opcion_compra">Diferencia</label>
          <div class="input-group">
            <input
              readonly
              type="tel"
              class="form-control text-center"
              :value="
                parseFloat(state.tir_objetivo) - parseFloat(state.tir_anterior)
              "
              autocomplete="off"
              id="opcion_compra"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group col-md-12 text-center mt-4">
          <button type="submit" class="btn btn-primary" :disabled="cargando">
            Guardar
          </button>
        </div>
      </div>
    </form>
  </section>
</template>
